import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class ChangeLogService {
  // 获取一条数据的变更记录
  static async getChangeListByClassFirst(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdChangeRecord/get-change-list-by-class-first', payload)
    )
    return Callback(err, res)
  }
  // 按实体获取变更记录
  static async getChangeListByClass(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdChangeRecord/get-change-list-by-class', payload)
    )
    return Callback(err, res)
  }
  // 按实体获取变更记录的表头
  static async getChangeListByClassHeader(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdChangeRecord/get-change-list-by-class-header', payload)
    )
    return Callback(err, res)
  }
  // 导出
  static async export(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdChangeRecord/export-chang-record', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
}
